<div class="d-flex cart-item-main">

  <div class="chevron-font">
    <div class="row toggle-container mb-2">
      <button [disabled]="!item.availableIndicator" class="custom-btn" id="toggle_destination"
        (click)="toggle(item.supplierItemIdentifier)">
        <label class="no-selection label-cursor">
          <i class="mdi" [ngClass]="(cartItemExpanded) ? 'mdi-chevron-up': 'mdi-chevron-down'"></i>
        </label>
      </button>
    </div>
  </div>

  <!-- Diamond Image -->
  <div class="mr-3 mb-3 image-thumb">
    <z-diamond-thumbnail
      [supplierUrls]="item | shoppingCartDetailsToDiamondThumbnail"
      [config]="imagesConfig"
      [displayAgsSpecificContent]="displayAgsSpecificContent">
    </z-diamond-thumbnail>
  </div>

  <div class="flex-fill container-cart">
    @if (showAgsIdentifier(item)) {
      <div class="d-flex flex-lg-row w-100 mb-2">
        <img class="ags-img" src="/assets/images/icons/shapes/partner-ags/Diamond.svg"  />
        <span class="ags-title">
          {{ 'Labels.ShoppingCart.AGS' | translate }}
        </span>
      </div>
    }
    <div class="details-wrapper d-flex">

      <div class="d-flex flex-wrap flex-fill">
        <!-- Unavailable item alert -->
        @if (!item.availableIndicator) {
          <div class="w-100">
            <div class="d-flex align-items-center not-available-alert font-14 alert alert-danger bg-white text-danger"
              role="alert">
              <i class="mdi mdi-alert-circle-outline mr-2 font-20"></i>
              <span>
                <span class="color-gray">
                  {{ 'Labels.ShoppingCart.UnavailableItem' | translate }}
                </span>
                <a (click)="searchSimilar.emit(item)" class="text-underline roboto-bold search-similar">
                  {{ 'Labels.ShoppingCart.SearchSimilar' | translate }}
                </a>
              </span>
            </div>
          </div>
        }

        <!-- Diamond information -->
        @if (agsUserAndItemAGSGraded) {
          <div class="d-flex flex-wrap diamond-info-wrapper w-100 ags-template">
            <div class="mr-5 mb-3 diamond-info-first-col">
              <!-- Item # -->
              <div class="mb-1 container-cart d-flex justify-content-between">
                <div class="font-20 color-gray ">
                  <span>{{ 'Labels.DiamondDetails.ItemId' | translate }}</span>
                  <span class="ml-1 roboto-bold">{{ item.supplierItemIdentifier }}</span>
                </div>

                <div class="d-none remove-item-sm">
                  <ng-container *ngTemplateOutlet="removeButton"></ng-container>
                </div>
              </div>

              <!-- Location -->
              <div class="mb-1 text-wrap color-gray">
                <span>{{ 'Labels.DiamondOrderDetails.Location' | translate }}</span>
                <span class="ml-1">
                  {{ item.sourceCountryCode }} {{ item.sourceRegionName ? ', ' + item.sourceRegionName : '' }}
                </span>
              </div>

              <!-- Cut grade-->
              @if (agsUserAndItemAGSGraded && item?.cutGrade) {
                <div class="mb-1">
                  <span class="color-gray mr-1">{{ 'Labels.DiamondDetails.CutGrade' | translate }}</span>
                  <span class="color-gray mr-1 roboto-bold">{{ item.cutGradeDescription || '-' }}</span>
                </div>
              }

              <!-- ProvenanceReport -->
              @if (item?.provenanceReportName) {
                <div class="mb-1 mt-1 color-gray">
                  <span class="mr-1">{{ 'Labels.DiamondDetails.ProvenanceReport' | translate }}</span>
                  @if (isSupplierProvidedSource && (item?.provenanceReportUrl | isSecureUrl)) {
                    <a class="roboto-bold text-info text-underline report-link"
                      [zThirdPartyRedirect]="item.provenanceReportUrl">
                      {{ item?.provenanceReportName }}
                    </a>
                  } @else {
                    <span id="provenance-report" class="font-weight-normal">{{ item?.provenanceReportName || '-' }}</span>
                  }
                </div>
              }
            </div>

            <div class="d-flex mr-2 mb-3 diamond-info-second-col">
              <div class="mr-5">
                <div class="font-20 mb-1 color-gray">
                  @if (diamondShapes?.includes(item?.shape)) {
                    <img height="18" class="mr-1"
                      src="/assets/images/icons/shapes/{{ item.shape }} - Dark.svg" />
                  }
                  <span class="roboto-bold">{{ item.shape }}</span>
                </div>
                <div class="mb-1 color-gray">
                  <span>{{ 'Labels.DiamondDetails.Clarity' | translate }}</span>
                  <span class="ml-1 roboto-bold">{{ item.clarity }}</span>
                </div>

                <!-- Light Performance -->
                @if (agsUserAndItemAGSGraded && item.lightPerformance) {
                  <div class="mb-1 color-gray">
                    <span>{{ 'Labels.DiamondDetails.LightPerformance' | translate }}</span>
                    <span class="ml-1 roboto-bold">{{ item.lightPerformance }}</span>
                  </div>
                }
              </div>
              <div class="mr-2">
                <div class="font-20 roboto-bold color-gray mb-1">
                  {{ item.carat }} {{ 'Labels.DiamondDetails.Carats' | translate }}
                </div>
                <div class="color-gray mb-1">
                  <span>{{ 'Labels.DiamondDetails.Color' | translate }}</span>
                  <span class="ml-1 roboto-bold font-13">{{ item.color }}</span>
                </div>
                <!-- Proportion factors -->
                @if (agsUserAndItemAGSGraded && item.proportionFactor) {
                  <div class="mb-1 color-gray">
                    <span class="mr-1">{{ 'Labels.DiamondDetails.ProportionFactor' | translate }}</span>
                    <span class="roboto-bold">{{ item.proportionFactor }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- Diamond information -->
          <div class="d-flex flex-wrap diamond-info-wrapper w-100">
            <div class="mr-2 mb-3 diamond-info-first-col">
              <!-- Grading Lab -->
              <div class="mb-1 color-gray">
                <span class="mr-1">{{ 'Labels.DiamondDetails.GradingLab' | translate }}</span>
                <span>{{ item.gradingLab || '-' }}</span>
              </div>

              <!-- Report Number -->
              <div class="mb-1">
                <span class="color-gray mr-1">{{(showAgsIdentifier(item) ? 'Labels.DiamondDetails.AgsNumber' : 'Labels.DiamondDetails.ReportNumber') | translate }}</span>
                <ng-container *ngTemplateOutlet="provenanceReportNumberTemplate"></ng-container>
              </div>

              <!-- Report type -->
              @if (agsUserAndItemAGSGraded && item.reportType) {
                <div class="mb-1">
                  <span class="color-gray mr-1">{{ 'Labels.DiamondDetails.AgsReportType' | translate }}</span>
                  <span class="color-gray mr-1 roboto-bold">{{ item.reportType}}</span>
                </div>
              }
              @if (item.offIdexList) {
                <div class="d-flex align-items-center mt-3">
                  <span class="off-idex-value font-10 px-2 my-1">{{ item.offIdexList }}%</span>
                  <span class="ml-1 color-gray">{{ 'Labels.DiamondDetails.OffIdexList' | translate }}</span>
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="d-flex flex-wrap diamond-info-wrapper">
            <div class="mr-5 mb-3 diamond-info-first-col">
              <!-- Item # -->
              <div class="mb-1 container-cart d-flex justify-content-between">
                <div class="font-20 color-gray ">
                  <span>{{ 'Labels.DiamondDetails.ItemId' | translate }}</span>
                  <span class="ml-1 roboto-bold">{{ item.supplierItemIdentifier }}</span>
                </div>

                <div class="d-none remove-item-sm">
                  <ng-container *ngTemplateOutlet="removeButton"></ng-container>
                </div>
              </div>

              <!-- Location -->
              <div class="mb-1 text-wrap color-gray">
                <span>{{ 'Labels.DiamondOrderDetails.Location' | translate }}</span>
                <span class="ml-1">
                  {{ item.sourceCountryCode }} {{ item.sourceRegionName ? ', ' + item.sourceRegionName : '' }}
                </span>
              </div>

              <!-- Grading Lab -->
              <div class="mb-1 color-gray">
                <span class="mr-1">{{ 'Labels.DiamondDetails.GradingLab' | translate }}</span>
                <span>{{ item.gradingLab || '-' }}</span>
              </div>

              <!-- Report Number -->
              <div class="mb-1">
                <span class="color-gray mr-1">{{ (showAgsIdentifier(item) ? 'Labels.DiamondDetails.AgsNumber' : 'Labels.DiamondDetails.ReportNumber') | translate }}</span>
                <ng-container *ngTemplateOutlet="provenanceReportNumberTemplate"></ng-container>
              </div>

              <!-- ProvenanceReport -->
              @if (item?.provenanceReportName) {
                <div class="mb-1 mt-1 color-gray">
                  <span class="mr-1">{{ 'Labels.DiamondDetails.ProvenanceReport' | translate }}</span>
                  @if (isSupplierProvidedSource && (item?.provenanceReportUrl | isSecureUrl)) {
                    <a class="roboto-bold text-info text-underline report-link"
                      [zThirdPartyRedirect]="item.provenanceReportUrl">
                      {{ item?.provenanceReportName }}
                      <!-- TODO: SHOULD OPENING THIS ALSO BE TRACKED -->
                    </a>
                  } @else {
                    <span id="provenance-report" class="font-weight-normal">{{ item?.provenanceReportName || '-' }}</span>
                  }
                </div>
              }
            </div>

            <div class="d-flex mr-2 mb-3 diamond-info-second-col">
              <div>
                <div class="font-20 mb-1 color-gray">
                  @if (diamondShapes?.includes(item?.shape)) {
                    <img height="18" class="mr-1"
                      src="/assets/images/icons/shapes/{{ item.shape }} - Dark.svg" />
                  }
                  <span class="roboto-bold">{{ item.shape }}</span>
                </div>
                <div class="mb-1 color-gray">
                  <span>{{ 'Labels.DiamondDetails.Clarity' | translate }}</span>
                  <span class="ml-1 roboto-bold">{{ item.clarity }}</span>
                </div>

                @if (item.offIdexList) {
                  <div class="d-flex align-items-center mt-1">
                    <span class="off-idex-value font-10 px-2 my-1">{{ item.offIdexList }}%</span>
                    <span class="ml-1 color-gray">{{ 'Labels.DiamondDetails.OffIdexList' | translate }}</span>
                  </div>
                }
              </div>

              <div class="ml-5">
                <div class="font-20 roboto-bold color-gray mb-1">
                  {{ item.carat }} {{ 'Labels.DiamondDetails.Carats' | translate }}
                </div>
                <div class="color-gray">
                  <span>{{ 'Labels.DiamondDetails.Color' | translate }}</span>
                  <span class="ml-1 roboto-bold font-13">{{ item.color }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Remove item action -->
      <div class="remove-item-lg">
        <ng-container *ngTemplateOutlet="removeButton"></ng-container>
      </div>
    </div>

    <div class="d-flex flex-lg-row flex-column flex-column-reverse">
      <!-- Save to Favorites and Search Similar Actions -->
      <div class="me-auto mb-2">

        <a class="roboto-bold text-info text-nowrap d-inline-block" (click)="searchSimilar.emit(item)">
          <i class="dripicons-search mr-1"></i>
          {{ 'Labels.ShoppingCart.SearchSimilar' | translate }}
        </a>
      </div>

      <div class="mb-3 mb-lg-0 diamond-info-last">
        <div class="text-lg-right font-14 color-gray mb-1">
          {{ 'Labels.DiamondDetails.PricePerCarat' | translate }}
          <span class="roboto-bold">{{ item.pricePerCarat | currency }}</span>
        </div>
        <div class="text-lg-right font-20 color-gray mb-1">
          <ng-container *ngTemplateOutlet="priceChangeTemplate"></ng-container>
          {{ 'Labels.ShoppingCart.DiamondPrice' | translate }}
          <span class="roboto-bold color-green">{{ item.price | currency }}</span>
        </div>

        @if ((isMarketplaceTariffsEnabled$ | async) && item.sourceCountryCode !== 'USA') {
          <span class="tariff-chip-bg-color roboto font-10 lh-16 tariff-chip-padding rounded-2 float-lg-end">
            {{ 'Labels.DiamondDetails.TariffTooltipLabel' | translate }}
          </span>
        }
      </div>
    </div>

    <z-spinner [inProgress]="cartItemLoading"></z-spinner>

    @if (cartItemExpanded && !cartItemLoading) {
      <div class="accord-body-wrap slide-in">
        @if (!cartItemError) {
          <z-cart-item-details [diamondDetails]="diamondDetails">
          </z-cart-item-details>
        } @else {
          <div class="alert alert-danger bg-danger align-items-center text-white border-0 mt-2 ml-1 alert-main"
            role="alert">
            <i class="uil-exclamation-circle mr-2 font-20 alert-icon-error"></i>
            <span class="font-13 mb-1 alert-text">{{ 'Errors.SystemError' | translate }}</span>
          </div>
        }
      </div>
    }

  </div>
</div>

<ng-template #provenanceReportNumberTemplate>
  @if (item.reportUrl | isSecureUrl) {
    <a
      class="roboto-bold text-info text-underline report-link"
      [title]="'Labels.DiamondDetails.GradingLabLinkTooltip' | translate"
      [zThirdPartyRedirect]="item.reportUrl"
      zProductTrackingAnalytics="Diamond Report Opened"
      [properties]="{
        ItemId: item.supplierItemIdentifier,
        ReportNumber: item.gradingReportNumber,
        Source: 'Shopping Cart',
        ProductType: ModuleType.NaturalDiamonds | moduleTypeToValue
      }"
    >
      {{ item.gradingReportNumber || '-' }}
    </a>
  } @else {
    <span class="roboto-bold color-gray">{{ item.gradingReportNumber || '-' }}</span>
  }
</ng-template>

<ng-template #priceChangeTemplate>
  @if (item.isPriceUpdated) {
    <i [ngbTooltip]="'Labels.DiamondDetails.PriceTotalUpdateTooltip' | translate"
      tooltipClass="zing-ui-tooltip left-tooltip" container="body" class="alert-icon mdi mdi-alert mr-1"
      [placement]="'top'" [triggers]="(responsivePopover$ | async)?.matches ? 'click' : 'hover'">
    </i>
  }
</ng-template>

<ng-template #removeButton>
  <a class="text-nowrap mb-3 text-danger roboto-bold" (click)="remove.emit(item)">
    <i class="mdi mdi-close"></i> {{ 'Remove' | translate }}
  </a>
</ng-template>
